let config = {};

const env = process.env.REACT_APP_ENV;

switch(env) {
  case "development":
    config = {
      apiHost: 'http://localhost:4000',
      stripe: {
        stripeKey: 'pk_test_e4q7MWpjoYvVfclU3T7DvEmX',
        name: "Videopeel", // the pop-in header title
        description: "Videopeel subscription payment", // the pop-in header subtitle
        buttonText: 'Sign Up',
        currency: 'USD',
        plans: {
          basic: {
            planId: "free"
          },
          pro: {
            planId: "pro",
            amount: 69,
            perMonthVideo: {
              limit: 10,
              debut: '2020-11-24 00:00:00'
            },
          },
          premium: {
            // Used to reproduce https://videopeel.atlassian.net/browse/V2-260
            oldPlansId: ["premium-invalid"],
            planId: "premium",
            amount: 399
          },
          enterprise: {
            planId: "enterprise",
            amount: 1000
          },
          proAnnually: {
            planId: "pro-annually",
            amount: 588,
            perMonthVideo: {
              limit: 10,
              debut: '2020-11-24 00:00:00'
            },
          },
          premiumAnnually: {
            planId: "premium-annually",
            amount: 2988
          },
          enterpriseAnnually: {
            planId: "enterprise-annually",
            amount: 10000
          },
          enterpriseMonthly: {
            planId: "enterprise-monthly",
            amount: 2000
          },
          amazonBasicMonthly: {
            planId: "price_1H2rZ0GddCycc7ZpodlEwUwa",
            amount: 69,
            perMonthVideo: {
              limit: 25,
            },
          },
          amazonBasicAnnual: {
            planId: "price_1H2raJGddCycc7ZpqfOpsGYu",
            amount: 588,
            perMonthVideo: {
              limit: 25,
            },
          },
          amazonPremiumMonthly: {
            planId: "price_1H2raqGddCycc7ZpYcJIat72",
            amount: 249
          },
          amazonPremiumAnnual : {
            planId: "price_1H2rbKGddCycc7Zp87Gy3ov8",
            amount: 2388
          }
        }
      },
      GoogleAuth: {
        clientId: "271699968826-o9prronf2ted8j5ve4nn4bi2valkoq6o.apps.googleusercontent.com"
      },
      AWS: {
        SiteAssets: "https://s3.amazonaws.com/videopeel-development",
        S3bucket: "https://s3.amazonaws.com/videopeel-development",
        GateWayURL: "https://srfukq2ekd.execute-api.us-east-1.amazonaws.com/stage/process-video",
        S3bucketName: "videopeel-development"
      },
      FACEBOOK: {
        appId: "2457067157728402"
      },
      trialPeriod: {
        days: 7
      },
      projectId: 257755,
      projectKey: '913f712f693843d510f39b4293af316f',
      VideoPeelSupportLink: "https://calendly.com/derek-217/vp-account-update",
      campaignIDs: ['k64bbg52','k7dmg3hc','k7dop0ti'],
      intercomAppID: 'uhfhkkts',
      campaignLimit: 2,
      errorBoundary: false,
      startVideoLink: "https://www.youtube.com/embed/m5E9Q5cdD6E",
      pluginURL: "https://pluginstaging.videopeel.com",
      baseAppDomain: "local.videopeel.com",
      promotionalCampaign: {
        enabled: true,
        pluginId: '90e5ac5a-cd74-483f-91c1-84daa4caf085',
        version: 1,
        maxViewCount: 2,
        expiresIn: null,
      },
      perMonthVideo: 50,
      googleAnalyticsId: 'UA-112744776-3'
    };
  break;

  case "staging":
    config = {
      apiHost: 'https://stagingapi.videopeel.com',
      stripe: {
        stripeKey: 'pk_test_e4q7MWpjoYvVfclU3T7DvEmX',
        name: "Videopeel", // the pop-in header title
        description: "Videopeel subscription payment", // the pop-in header subtitle
        buttonText: 'Sign Up',
        currency: 'USD',
        plans: {
          basic: {
            planId: "free"
          },
          pro: {
            planId: "pro",
            amount: 69,
            perMonthVideo: {
              limit: 10,
              debut: '2020-11-24 00:00:00'
            },
          },
          premium: {
            // Used to reproduce https://videopeel.atlassian.net/browse/V2-260
            oldPlansId: ["premium-invalid"],
            planId: "premium",
            amount: 399
          },
          enterprise: {
            planId: "enterprise",
            amount: 1000
          },
          proAnnually: {
            planId: "pro-annually",
            amount: 588,
            perMonthVideo: {
              limit: 10,
              debut: '2020-11-24 00:00:00'
            },
          },
          premiumAnnually: {
            planId: "premium-annually",
            amount: 2988
          },
          enterpriseAnnually: {
            planId: "enterprise-annually",
            amount: 10000
          },
          enterpriseMonthly: {
            planId: "enterprise-monthly",
            amount: 2000
          },
          amazonBasicMonthly: {
            planId: "price_1H2rZ0GddCycc7ZpodlEwUwa",
            amount: 69,
            perMonthVideo: {
              limit: 25,
            },
          },
          amazonBasicAnnual: {
            planId: "price_1H2raJGddCycc7ZpqfOpsGYu",
            amount: 588,
            perMonthVideo: {
              limit: 25,
            },
          },
          amazonPremiumMonthly: {
            planId: "price_1H2raqGddCycc7ZpYcJIat72",
            amount: 249
          },
          amazonPremiumAnnual : {
            planId: "price_1H2rbKGddCycc7Zp87Gy3ov8",
            amount: 2388
          }
        },
      },
      GoogleAuth: {
        clientId:"271699968826-n516e2dad90ll393c7v5o25q740t8j6l.apps.googleusercontent.com"
      },
      AWS: {
        SiteAssets: "https://s3.amazonaws.com/videopeel-development",
        S3bucket: "https://s3.amazonaws.com/videopeel-development",
        GateWayURL: "https://srfukq2ekd.execute-api.us-east-1.amazonaws.com/stage/process-video",
        S3bucketName: "videopeel-development"
      },
      FACEBOOK: {
        appId: "2457067157728402"
      },
      trialPeriod: {
        days: 7
      },
      projectId: 257755,
      projectKey: '913f712f693843d510f39b4293af316f',
      VideoPeelSupportLink: "https://calendly.com/derek-217/vp-account-update",
      campaignIDs: ['k64bbg52','k7dmg3hc','k7dop0ti'],
      intercomAppID: 'uhfhkkts',
      campaignLimit: 2,
      errorBoundary: false,
      startVideoLink: "https://www.youtube.com/embed/m5E9Q5cdD6E",
      pluginURL: "https://pluginstaging.videopeel.com",
      baseAppDomain: "staging.videopeel.com",
      promotionalCampaign: {
        enabled: true,
        pluginId: '90e5ac5a-cd74-483f-91c1-84daa4caf085',
        version: 1,
        maxViewCount: 2,
        expiresIn: null,
      },
      perMonthVideo: 50,
      googleAnalyticsId: 'UA-112744776-3'
    };
  break;

  case "production":
    config = {
      apiHost: 'https://api.videopeel.com',
      stripe: {
        stripeKey: 'pk_live_rKKRZqdk6OPtJkSWe6YCmhlV',
        name: "Videopeel", // the pop-in header title
        description: "Videopeel subscription payment", // the pop-in header subtitle
        buttonText: 'Sign Up',
        currency: 'USD',
        plans: {
          basic: {
            planId: "free"
          },
          pro: {
            oldPlansId: ["plan_Eo9RGo1vW6jr5x"],
            planId: "plan_GcgUejNNXClIwi",
            amount: 69,
            perMonthVideo: {
              limit: 10,
              debut: '2020-11-24 00:00:00'
            },
          },
          premium: {
            oldPlansId: ["plan_GcgYRz69NITi3X", "plan_FHjyi8YjF6DOTL"],
            planId: "plan_H3dvqapPNg3rYY",
            amount: 399
          },
          enterprise: {
            planId: "plan_H3e1Q7cBYJZp0z",
            amount: 1000
          },
          proAnnually: {
            planId: "plan_H3e9KsEYNAzD1K",
            amount: 588,
            perMonthVideo: {
              limit: 10,
              debut: '2020-11-24 00:00:00'
            },
          },
          premiumAnnually: {
            planId: "plan_H3eCryd5JCaxgE",
            amount: 2988
          },
          enterpriseAnnually: {
            planId: "plan_H3eLFlACpGpOnb",
            amount: 10000
          },
          enterpriseMonthly: {
            planId: "price_1HJmgnGddCycc7ZpXc3w39r9",
            amount: 2000
          },
          amazonBasicMonthly: {
            planId: "price_1H2r02GddCycc7ZpEoeJBhGu",
            amount: 69,
            perMonthVideo: {
              limit: 25,
            },
          },
          amazonBasicAnnual: {
            planId: "price_1H2r2jGddCycc7ZpwTmAvvzm",
            amount: 588,
            perMonthVideo: {
              limit: 25,
            },
          },
          amazonPremiumMonthly: {
            planId: "price_1H2r3qGddCycc7ZpPdUIMciS",
            amount: 249
          },
          amazonPremiumAnnual : {
            planId: "price_1H2r56GddCycc7Zp0JXIpJTX",
            amount: 2388
          }
        }
      },
      GoogleAuth: {
        clientId: "271699968826-n516e2dad90ll393c7v5o25q740t8j6l.apps.googleusercontent.com"
      },
      AWS:{
        SiteAssets: "https://d2fr8icwxgw12b.cloudfront.net",
        S3bucket: "https://s3.amazonaws.com/videopeel-production",
        GateWayURL: "https://srfukq2ekd.execute-api.us-east-1.amazonaws.com/prod/process-video",
        S3bucketName: "videopeel-production"
      },
      FACEBOOK: {
        appId: "454904778263732"
      },
      trialPeriod: {
        days: 7
      },
      projectId: 257755,
      projectKey: '913f712f693843d510f39b4293af316f',
      VideoPeelSupportLink: "https://calendly.com/derek-217/vp-account-update",
      campaignIDs: ['k64bbg52','k7dmg3hc','k7dop0ti'],
      intercomAppID: 'uhfhkkts',
      campaignLimit: 2,
      errorBoundary: true,
      startVideoLink: "https://www.youtube.com/embed/m5E9Q5cdD6E",
      pluginURL: "https://plugin.videopeel.com",
      baseAppDomain: "videopeel.com",
      promotionalCampaign: {
        enabled: true,
        pluginId: '9e26b224-b507-4df7-8cb0-5f875c2d8866',
        version: 1,
        maxViewCount: 2,
        expiresIn: null,
      },
      perMonthVideo: 50,
      googleAnalyticsId: 'UA-112744776-2'
    };
  break;
  default:
    throw new Error(`Missing or unsupported REACT_APP_ENV enviroment variable: ${env}`);
}

module.exports = config;



// WEBPACK FOOTER //
// ./src/config.js